import { render, staticRenderFns } from "./DPInstanceDetail.vue?vue&type=template&id=6293d8b5&"
import script from "./DPInstanceDetail.vue?vue&type=script&lang=js&"
export * from "./DPInstanceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports